import { makeColorStrip } from "./makeColorStrip"

export const makeStripe = points => {
  const colorstrip = makeColorStrip(points)
  return `linear-gradient(90deg, ${colorstrip}`
}
